import { api, newApi, umsApi } from "../AxiosInstance";

export function getOrgApi(params) {
  return api().get("api/Organization/GetAll", { params });
}

export function getTenantsApi(params) {
  return api().get("api/Tenant/GetAllTenantByOrganization", { params });
}

export function addOrgApi(data) {
  return api().post("api/Organization/Register", data);
}

export function editOrgApi(data) {
  return api().put("api/Organization/Update", data);
}

export function addTenantApi(data) {
  return api().post("/api/Tenant/CreateByCurrentOrganization", data);
}

export function editTenantApi(data) {
  return api().put("/api/Tenant/Update", data);
}

export function SetCustomSmsApi(data) {
  return api().put("/api/Account/SetCustomSMSSettings", data);
}

export function getCustomSmsApi(params) {
  return api().get("/api/Account/GetCustomSMSSettings", { params });
}

export function ManuallyCVRPSagaApi(data) {
  return api().post("/api/PlanService/ExecuteToolManualLaunchMode", data);
}

export function getOrgByIdApi(params) {
  return api().get("api/Organization/GetOrganizationById", { params });
}

export function changeOrgActivationApi(data) {
  return api().put("api/Organization/DeactivateOrganizationById", data);
}

export function changeTenantActivationApi(data) {
  return api().put("/api/Tenant/DeactivateTenantById", data);
}

export function getTenantByIdApi(params) {
  return api().get("/api/Tenant/GetById", { params });
}

export function deleteTenantApi(params) {
  return api().delete("/api/Tenant/DeleteById", { params });
}

export function getOrganizationUserApi(params) {
  return api().get("/api/User/GetOrganizationUser", { params });
}

export function DownloadExcelFileApi(params) {
  return api().get("/api/PlanService/DownloadPlanFile", { params });
}

export function getTenantUserApi(params) {
  return api().get("/api/User/GetTenantUser", { params });
}

export function getUserOfTenantApi(params) {
  return api().get("/api/User/GetById", { params });
}

export function updateOrgUserApi(data) {
  return api().put("/api/User/UpdateOrganizationUser", data);
}

export function updateTenantUserApi(data) {
  return api().put("/api/User/UpdateTenantUser", data);
}

export function restorePlanApi(data) {
  return api().put("/api/Planning/RestoreDeletedPlan", data);
}

export function changeTenantPasswordApi(data) {
  return api().put("/api/User/ChangePasswordOfTenant", data);
}

export function changeOrganizationPasswordApi(data) {
  return api().put("/api/User/ChangePasswordOfOrganization", data);
}

export function setPlanStatusApi(data) {
  return api().put("/api/Planning/SetPlanStatus", data);
}

export function getUserTokenApi(params) {
  return api().get("/api/Auth/GetTokenForUser", { params });
}

export function getOrgsListIdApi(params) {
  return api().get("/api/Organization/GetAllOrganizationsIdAndName", {
    params,
  });
}

export function getUserTokenByTenantIdApi(params) {
  return api().get("/api/Auth/GetTokenForTenant", { params });
}

export function getOrganizationUsageApi(params) {
  return api().get("/api/Account/GetOneOrganizationUsage", { params });
}

export function getOrganizationsUsageApi(params) {
  return api().get("/api/Account/GetAllOrganizationsUsage", { params });
}

export function downloadUsageApi(params) {
  return api().get("/api/Account/DownloadUsage", { params });
}

export function DownloadResultOptimzeFileApi(params) {
  return api().get("/api/PlanService/DownloadResultOptimzeFile", { params });
}

export function getOrgPOCApi(params) {
  return api().get("/api/Organization/GetOrganizationPOCType", { params });
}

export function updateOrgPOCApi(data) {
  return api().put("/api/Organization/UpdateOrganizationPOCType", data);
}

export function addOrgPOCApi(data) {
  return api().put("/api/Organization/SetOrganizationPOCType", data);
}

export function removeOrgPOCApi(params) {
  return api().delete("/api/Organization/DeleteOrganizationPOCType", {
    params,
  });
}

export function OrgAdminsApi(params) {
  return api().get("/api/OrganizationAdmin/GetAll", { params });
}

export function addOrgAdminApi(data) {
  return api().post("/api/OrganizationAdmin/Register", data);
}

export function getAllPlansApi(params) {
  return api().get("/api/Planning/GetAllPlans", { params });
}

export function setWebhookConfigApi(data) {
  return api().put("/api/Account/SetWebHookConfig", data);
}

export function getWebhookConfigApi(params) {
  return api().get("/api/Account/GetWebHookConfig", { params });
}

export function setVerificationCodeConfigApi(data) {
  return api().put("/api/Account/SetDeliveryVerificationParams", data);
}

export function getVerificationCodeConfigApi(params) {
  return api().get("/api/Account/GetDeliveryVerificationParams", { params });
}

export function changeUserActivationApi(useId) {
  return api().post("/api/User/ChangeUserActivation?userId=" + useId);
}

export function createTenantUserApi(data) {
  return api().post("/api/Tenant/CreateTenantSubUser", data);
}

export function createOrgUserApi(data) {
  return api().post("/api/Organization/CreateOrganizationUser", data);
}

export function getRoleFlagApi(params) {
  return api().get("/api/Tenant/GetRoleFlags", { params });
}

export function getOrgRoleFlagApi(params) {
  return api().get("/api/Organization/GetRoleFlags", { params });
}

export function getAllTenantUsersApi(data) {
  return api().post("/api/Tenant/GetAllTenantUsers", data);
}

export function getAllOrgUsersApi(data) {
  return api().post("api/Organization/GetAllOrganizationUsers", data);
}

export function getMissionReasonApi(params) {
  return api().get("/api/Organization/GetMissionReasons", {params});
}

export function addMissionReasonApi(data) {
  return api().post("/api/Organization/AddMissionReason", data);
}

export function deleteMissionReasonApi(data) {
  return api().post("/api/Organization/DeleteMissionReason", data);
}

export function updateMissionReasonApi(data) {
  return api().put("/api/Organization/UpdateMissionReason", data);
}

export function changeUserPasswordApi(data) {
  return api().post("/api/User/ChangeUserPassword", data);
}

export function getRoleOrgsApi() {
  // return api().get("api/Organization/GetAll", { params });
  return umsApi().get("/Organization/GetAll");
}

export function addRoleApi(data) {
  return umsApi().post("/Roles/Create", data);
}

export function deleteRoleApi(item) {
  return umsApi().delete(`/Roles/Delete/${item.id}`);
}

export function editRoleApi(data) {
  return umsApi().put("/Roles/Update", data);
}

export function getAllRolesApi() {
  return umsApi().get("/Roles/GetAll");
}

export function getRoleByIdApi(id) {
  return umsApi().get(`/Roles/Get/${id}`);
}

export function getMenuApi(data) {
  return umsApi().get("/Menus/GetAll", data);
}

export function getActionApi(data) {
  return umsApi().get("/Actions/GetAll", data);
}

export function getLogsApi(params) {
  return api().get("/api/PlanService/GetPlanLogs", { params });
}

export function clonePlanApi(data) {
  return api().post("/api/Planning/ClonePlan", data);
}

export function turnBackPlanApi(data) {
  return api().post("/api/Planning/ReturnClonePlan", data);
}

export function createAppVersionApi(data) {
  return api().post("/api/MobileSetting/CreateMobileAppVersion", data);
}

export function getAllContractsApi(params) {
  return api().get("/api/Account/AllContractsFiltered", { params });
}
export function addContractApi(data) {
  return api().post("/api/Account/AddContract", data);
}
export function deleteContractApi(item) {
  return api().delete(`/api/Account/DeleteContract?id=${item.contractId}`);
}
export function editContractApi(item) {
  return api().put(`/api/Account/UpdateContract?id=${item.contractId}`, item);
}
export function removeOrganizationAccessByContractEndApi(organizationId) {
  return api().post(
    `/api/Account/RemoveOrganizationAccessByContractEnd?organizationId=${organizationId}`
  );
}
export function removeReminderApi(items) {
  return api().post('/api/Account/PausePackageItemNotificationSchedule' + `?organizationId=${items.organizationId}&paused=${items.paused}`);
}
export function getAccountUsageApi(data) {
  return api().get(`/api/Account/GetAccountUsageData?organizationId=${data}`);
  // return newApi().get(
  //   `/api/Account/GetAccountUsageData?organizationId=${data}`
  // );
}

export function apiGetPlanFlowProcess(params) {
  return api().get(`/api/Planning/GetPlanFlowProcess`, { params });
}


export function apiGetRabbitMqHealth() {
  return api().get(`/health`);
}